import { createRouter, createWebHistory } from 'vue-router';
 import RoomView from '../views/RoomView.vue';
import DeviceView from '@/views/DeviceView.vue';
 import RoomViewOne from '../views/RoomViewOne.vue';


const routes = [
  {
    path: '/',
    name: '/',
    component: RoomViewOne,
  },
  {
    path: '/room',
    name: 'RoomView',
    component: RoomView,
  },
  {
    path: '/device',
    name: 'DeviceView',
    component: DeviceView,
  },

];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;